import { useEffect, useState } from "react"
import { StepWizard, Wizard } from "../../bpm/config/Componentes/wizard/Wizard"
import { BasicPage } from "../../theme/Component/BasicPage"
import { TraslateForm } from "./traslatebudget/TraslateForm";
import { BudgetList } from "./traslatebudget/BudgetList";
import { GenerateTraslate } from "./traslatebudget/GenerateTraslate";


export const TraslateBudget = () => {

    const [formData, setFormData] = useState<any>({});
    const [responseDocument, setResponseDocument] = useState<any>({});
    const [canDiscard, setCanDiscard] = useState<boolean>(false);
    const validarContrato = () => {
    }

    useEffect(() => {
        if (responseDocument?.MSGList?.length > 0) {
            setCanDiscard(true)
        } else {
            setCanDiscard(false)
        }
    }, [responseDocument])


    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Formulario',
            onEvent: validarContrato,
            children: <TraslateForm onChange={setFormData} />,
            validButton: (formData?.Year && formData?.YearTO && formData?.IDBudgetType && formData?.Type),
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2.Documentos a trasladar',
            onEvent: validarContrato,
            children: <BudgetList data={formData} onChange={setFormData} />,
            validButton: formData?.List?.length > 0,
            canReturn: true
        },
        {
            keyID: "2",
            name: 'PASO 3. Generar Documento',
            onEvent: validarContrato,
            children: <GenerateTraslate data={formData} onChange={setFormData} />,
            validButton: false,
            canReturn: false,
            canDiscard: canDiscard
        }
    ]
    return (
        <BasicPage titulo="Traslado presupuesto entre vigencias">
            {/* <PrintJson json={formData} /> */}
            <Wizard title="Presupuesto" listStep={steps} />
        </BasicPage>
    )
}